import React from "react";
import useSound from "use-sound";
import DBLPOP from "../../../assets/music/DBLPOP.mp3";
import s from "./style.module.css";
const QuizType2 = ({
  item,
  index,
  // answer,
  handleGetAnswer,
  handleClickSpeaker,
  speakerImg,
}) => {
  const [play] = useSound(DBLPOP);
  // const ansFromRedux = answer.filter(
  //   (ans) => ans.question_id === item.question_id
  // );
  return (
    <div className={s.QuizType2Container}>
      <div>
        <span>
          {/* {`${index + 1})`}  */}
          {item.question_label}
        </span>
      </div>
      <div className={s.ChoiceType2Container}>
        {item.choices.map((item2, idx) => (
          <div
            key={idx}
            className={s.ChoiceType2Wrapper}
            onClick={() => {
              handleGetAnswer(item.question_id, item2.id, item.quizType);
              play();
            }}
          >
            <p>{item2.choice_label}</p>
            <p>{item2.subText}</p>
            {!!item2.additionImg && (
              <img
                style={{
                  width: "40%",
                  height: "40%",
                  position: "absolute",
                  right: 0,
                  bottom: 0,
                }}
                src={item2.additionImg}
                alt="addition"
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuizType2;
